import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import FullPageIcon from '@mui/icons-material/Web';  // Correctly import FullPageIcon
import PaperIcon from '@mui/icons-material/Description';  // Correctly import PaperIcon
import { useFormTheme } from '../../../contexts/FormThemeContext';  // Adjust the import path as necessary
import themes from './FormThemeConfig'; // Import themes configuration

const ThemeSettings = () => {
  const { selectedTheme, setSelectedTheme } = useFormTheme(); // Use the new hook
  if (!selectedTheme) return null;

  // Generate theme buttons based on the themes defined in FormThemeConfig
  const themeKeys = Object.keys(themes);
  const themeDetails = {
    "Full Page": { icon: <FullPageIcon />, description: 'A full-page form without any visual boundaries.' },
    "Paper": { icon: <PaperIcon />, description: 'A paper-like form with a contained layout.' },
    // More themes can be added here with their corresponding icons and descriptions
  };

  const handleThemeClick = (themeName) => {
  console.log("Setting theme to: ", themeName);
    setSelectedTheme(themeName);  // Update theme using context
  };

  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'flex-start',
      padding: '0px 0 0 0',
      overflow: 'hidden'
    }}>
      {themeKeys.map((themeName) => (
        <Button
          key={themeName}
          variant={selectedTheme === themeName ? 'contained' : 'outlined'}
          onClick={() => handleThemeClick(themeName)}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '70px',
            ml: 2,
            padding: '8px 0',
            textTransform: 'none',
            backgroundColor: selectedTheme === themeName ? 'primary.main' : 'transparent',
            color: selectedTheme === themeName ? 'primary.contrastText' : 'text.primary',
            borderColor: selectedTheme === themeName ? 'primary.main' : 'grey.400',
            '&:hover': {
              backgroundColor: selectedTheme === themeName ? 'primary.dark' : 'transparent',
              borderColor: selectedTheme === themeName ? 'primary.dark' : 'grey.400',
            }
          }}
        >
          {themeDetails[themeName].icon}
          <Typography variant="caption" sx={{ mt: 1 }}>{themeName}</Typography>
        </Button>
      ))}
    </Box>
  );
};

export default ThemeSettings;
